export const answerSheetWsMessageTypes = {
  send: {
    UPDATE_QUESTION: "update_question",
    FINISH_TEST: "finish_test",
    PAUSE_TEST: "pause_test",
    RESUME_TEST: "resume_test",
  },
  receive: {
    REVEAL_ANSWER: "reveal_answer",
    START_TEST: "start_test",
    TEST_COMPLETED: "test_completed",
    TEST_PAUSED: "test_paused",
    TEST_RESUMED: "test_resumed",
  },
};

export const messagingInboxWsMessageTypes = {
  send: {
    SUBSCRIBE: "subscribe",
    UNSUBSCRIBE: "unsubscribe",
    REFRESH: "refresh",
  },
  receive: {
    SUBSCRIBED: "subscribed",
    UNSUBSCRIBED: "unsubscribed",
    INBOX_UPDATE: "inbox_update",
    INBOX_SNAPSHOT: "inbox_snapshot",
    ERROR: "error",
  },
};

export const messagingConversationWsMessageTypes = {
  send: {
    SUBSCRIBE: "subscribe",
    UNSUBSCRIBE: "unsubscribe",
    MARK_READ: "mark_read",
    TYPING_START: "typing_start",
    TYPING_STOP: "typing_stop",
    RESOLVE: "resolve",
    REOPEN: "reopen",
  },
  receive: {
    SUBSCRIBED: "subscribed",
    UNSUBSCRIBED: "unsubscribed",
    CONVERSATION_SNAPSHOT: "conversation_snapshot",
    MESSAGE: "message",
    TYPING_EVENT: "typing_event",
    READ_EVENT: "read_event",
    ERROR: "error",
  },
};

export const messagingNotifyWsMessageTypes = {
  send: {
    SUBSCRIBE: "subscribe",
    UNSUBSCRIBE: "unsubscribe",
  },
  receive: {
    NOTIFY_READY: "notify_ready",
    NOTIFY: "notify",
    NOTIFY_UPDATE: "notify_update",
    SUBSCRIBED: "subscribed",
    UNSUBSCRIBED: "unsubscribed",
    ERROR: "error",
  },
};
